import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { Span, Typography } from "@faire/web--source/slate/Typography";
import { Money } from "@faire/web--source/ui/Money";
import React from "react";
import styled from "styled-components";
import { showProductPromotions } from "@faire/retailer/lib/showProductPromotions";
export var OpenSizingVariationLabel = function(param) {
    var variation = param.variation;
    var label = variation.size;
    var disabled = variation.inventory === 0;
    var costSuffix = variation.wholesalePrice;
    var promoPrice = variation.promoPrice;
    var _promoPrice_discounted_item_price;
    return /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        gap: "1x",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                "data-test-id": "open-sizing-size-".concat(label),
                children: disabled ? /*#__PURE__*/ _jsx(StrikeThrough, {
                    children: label
                }) : label
            }),
            costSuffix ? /*#__PURE__*/ _jsxs(Typography, {
                variant: "labelSansRegular",
                color: Core.text.subdued,
                "data-test-id": "open-sizing-".concat(label, "-variation-suffix"),
                children: [
                    "(",
                    showProductPromotions(promoPrice) ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(StrikeThrough, {
                                children: /*#__PURE__*/ _jsx(Money, {
                                    money: costSuffix
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Span, {
                                color: Decorative.shade.orange,
                                children: [
                                    " ",
                                    /*#__PURE__*/ _jsx(Money, {
                                        money: promoPrice.discounted_item_price
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx(Money, {
                        money: (_promoPrice_discounted_item_price = promoPrice === null || promoPrice === void 0 ? void 0 : promoPrice.discounted_item_price) !== null && _promoPrice_discounted_item_price !== void 0 ? _promoPrice_discounted_item_price : costSuffix
                    }),
                    ")"
                ]
            }) : undefined
        ]
    });
};
var StrikeThrough = styled.span.withConfig({
    componentId: "sc-5ea422ae-0"
})([
    "text-decoration:line-through;color:",
    ";"
], Core.text.subdued);
